<template>
  <div class="container" :class="type">
    <lessonIframe
      :id="id"
      @back="back"
      type="teaching"
      ref="lessonIframe"
      @runStep="runStep" />
    <img v-if="!isRunStep" src="@/assets/img/icon_fan_z.png" alt="" class="back" @click="back">
  </div>
</template>
<script>

import lessonIframe from '@/components/lessonIframe'

export default {
  props: {
    id: {
      type: Number,
      default: undefined
    },
    type: {
      type: Number,
      default: undefined
    }
  },
  components: {
    lessonIframe
  },
  data() {
    return {
      iframeUrl: '',
      isRunStep: false // 编辑器练习是否运行
    }
  },
  methods: {
    back(check = true) {
      console.log(check)
      if (this.type === 'editor' && check) {
        this.$refs.lessonIframe.editorBack()
      } else {
        this.$emit('back')
      }
    },
    runStep(data) {
      this.isRunStep = data.isRunStep
    }
  },
  mounted() {
    console.log(this.type)
    window.addEventListener('message', this.receiveMessage, false) // 获取iframe传来的信息
  }
}
</script>

<style lang="less" scoped>
.container{
  width: 100%;
  height: calc(100vh - 100px);
  position: relative;
}
.editor{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}
.back{
  position: absolute;
  left: 25px;
  top: 20px;
  cursor: pointer;
  width: 34px;
  border-radius: 4px;
  background: #fff;
}
</style>
